import { render, staticRenderFns } from "./packagePicker.vue?vue&type=template&id=3810231a"
import script from "./packagePicker.vue?vue&type=script&lang=js"
export * from "./packagePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports